import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class UserProfileForm extends BaseComponent {
	
	static get properties() {
		return {
			// Do not declare Lit "style" — it shadows HTMLElement.style and breaks
			// Vaadin dialog focus trapping (isElementHiddenDirectly).
			showcancel: {type: String}
		};
	}
	
	constructor() {
		super();
						
		var userForm = this;
		setTimeout(function(){
			userForm.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var userForm = this;
		
		
		userForm.notificationPerference = [];
		var notificationPerferenceGrid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true				
			},			
			children: [	
				{						
					path: 'urgencyLevel',
					header: 'Urgency Level',					
					width: '7em'
				},
				{
					path: 'delayMinutes',
					header: 'Delay Minutes',					
					'flex-grow': '1'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					notificationPerferenceGrid.selectedItems = item ? [item] : [];
					if (notificationPerferenceGrid.selectedItems.length > 0) {											
						ElementUtil.query(userForm.formPanel, 'editItem').disabled = false;
						ElementUtil.query(userForm.formPanel, 'removeItem').disabled = false;
					} else {	
						ElementUtil.query(userForm.formPanel, 'editItem').disabled = true;										
						ElementUtil.query(userForm.formPanel, 'removeItem').disabled = true;
					}	
				}
			}
		});		
		
		userForm.formPanel = ElementUtil.create({
			tag: 'dl-form-panel',
			style: userForm.style.cssText ? userForm.style.cssText : '',
			itemid: 'form',
			children: [
				{
					tag: 'vaadin-form-layout',										
					children: [
						{
							tag: 'input',
							type: 'hidden',
							name: 'userId'
						},
						{
							tag: 'vaadin-text-field',
							name: 'firstname',
							label: 'First Name',
							required: true,
							maxlength: 120
						},
						{
							tag: 'vaadin-text-field',
							name: 'lastname',
							label: 'Last Name',
							required: true,
							maxlength: 120
						},
						{
							tag: 'vaadin-email-field',
							name: 'email',
							label: 'Email',
							required: true,
							maxlength: 120
						},
						{
							tag: 'vaadin-text-field',
							name: 'phone',
							label: 'Phone',
							maxlength: 120
						},	
						{
							tag: 'vaadin-combo-box',
							label: 'UI Color Mode', 
							name: 'uiColorMode',
							'item-value-path': 'code',
							'item-label-path': 'description',							
							postinit: function(combo) {
								combo.items = [
									{										
										code: 'dark',
										description: 'Dark'
									},
									{										
										code: 'light',
										description: 'Light (default)'
									},
									{										
										code: 'system',
										description: 'System'
									}
								];
							}
						},
						{
							tag: 'vaadin-checkbox',
							name: 'saveDataLayout',
							label: 'Save data layout',
							colspan: 2
						},
						{
							tag: 'dl-section-title',
							title: 'Notification Preferences',
							style: 'margin-top: 10px;',
							colspan: 2
						},						
						{
							tag: 'div',
							style: 'height: 250px;',
							colspan: 2,
							children: [
								{
									tag: 'dl-flex-layout',
									children: [
										{
											tag: 'dl-toolbar',
											slot: 'toolbar',
											theme: 'spacing',
											children: [																				
												{
													tag: 'vaadin-button',
													itemid: 'addItem',
													theme: 'primary',
													'class': 'spacer-toolbar-item',
													children:[
														ElementUtil.makeIcon('vaadin:plus', ' Add')
													],
													listeners: {
														click: function() {							
															actionAddEditNotificationPref();
														}
													}					
												},	
												{
													tag: 'vaadin-button',
													itemid: 'editItem',																	
													'class': 'spacer-toolbar-item',
													children:[
														ElementUtil.makeIcon('vaadin:edit', ' Edit')
													],
													listeners: {
														click: function() {							
															actionAddEditNotificationPref(notificationPerferenceGrid.selectedItems[0]);
														}
													}					
												},
												{
													tag: 'vaadin-button',
													itemid: 'removeItem',
													theme: 'error primary',																						
													'class': 'spacer-toolbar-item',
													style: 'float: right;',					
													children:[
														ElementUtil.makeIcon('vaadin:close', ' Remove')
													],
													listeners: {
														click: function() {
															actionRemoveNotificationPref(notificationPerferenceGrid.selectedItems[0]);
														}
													}
												}			
											]
										},
										notificationPerferenceGrid										
									]
								}								
							]
						},
						{
							tag: 'div',
							itemid: 'lastSent',
							innerHTML: 'Last Sent: ',
							colspan: 2
						},
						{
							tag: 'hr',
							colspan: 2
						},
						{
							tag: 'div',
							style: 'text-align: center;',
							colspan: 2,
							defaults: {
								tag: 'vaadin-button'
							},
							children: [
								{
									theme: 'primary',
									children: [
										ElementUtil.makeIcon('vaadin:database', ' Save')
									],
									listeners: {
										click: function() {											
											userForm.formPanel.submitForm({	
												preSubmit: function(data) {
													
													data.userMessagePreference = {
														urgencyDelay: {}
													};
													
													if (userForm.notificationPerference.length >= 0) {
														userForm.notificationPerference.forEach(function(item){
															data.userMessagePreference.urgencyDelay[item.urgencyLevel] = item.delayMinutes;
														});
													}													
												},												
												actualCall: function(data) {
													return Service.getUserService().updateProfile(data);
												},
												success: function(data, responseData) {													
													window.DL.MessageUtil.showToast('Success', 'Saved User Profile', {									
														theme: 'success',
														position: 'top-stretch'
													});

													Service.getUserService().clearCurrentUser();
													Service.getUserService().getCurrentUser().then(function(user) {
														window.DL.currentUser = user;
														if (user.userProfile && user.userProfile.uiColorMode) {
															window.DL.switchMainCss(user.userProfile.uiColorMode);
														}
													});
													
													var actionEvent = new CustomEvent('saved', { detail: responseData });
													userForm.dispatchEvent(actionEvent);
												}
											});
										}
									}
								},
								{
									theme: 'tertiary',
									innerHTML: 'Cancel',
									style: 'margin-left: 10px;',
									'class': userForm.showcancel ? '' : 'hide',
									listeners: {
										click: function() {
											var actionEvent = new CustomEvent('cancel', { detail: '' });
											userForm.dispatchEvent(actionEvent);
										}
									}
								}
							]
						}
					]
				}
			]
		});
		
		userForm.append(userForm.formPanel);
		
		setTimeout(function(){
			var readyEvent = new CustomEvent('ready', { detail: '' });
			userForm.dispatchEvent(readyEvent);
		}, 10);
		
		var actionAddEditNotificationPref = function (notPerf) {
			var addEditItemWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Notification Preference',
				icon: 'lumo:edit',
				width: .65,
				height: 175,
				listeners: {
					ready: function () {
						addEditItemWin.show();

						var notFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'vaadin-combo-box',
											label: 'Urgency Level',
											name: 'urgencyLevel',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('UrgencyLevel').then(function (data) {
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-number-field',
											label: 'Delay Minutes',
											name: 'delayMinutes',
											required: true,
											min: 0,
											max: 9999999
										},																								
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {																			

															var data = notFormPanel.getData();	

															var add = true;	
															userForm.notificationPerference.forEach(function(item){
																if (item.urgencyLevel === data.urgencyLevel) {
																	item.delayMinutes = data.delayMinutes;
																	add = false;
																}
															});
															if (add) {
																userForm.notificationPerference.push(data);
															}

															userForm.actionRefreshNotPref();
															addEditItemWin.close();

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															//cancel
															addEditItemWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditItemWin.addToContentElement(notFormPanel);

						if (notPerf) {
							//load details ...unpack																		
							notFormPanel.load(notPerf);
						}

					}
				}
			});

		};
						
		userForm.actionRefreshNotPref = function() {
			notificationPerferenceGrid.activeItem = null;
			notificationPerferenceGrid.items = userForm.notificationPerference.slice(0);
		};

		var actionRemoveNotificationPref = function(notPerf) {
			var newItems = [];
			userForm.notificationPerference.forEach(function(item){
				if (item.urgencyLevel !== notPerf.urgencyLevel) {
					newItems.push(item);
				}
			});	
			userForm.notificationPerference = newItems;
			userForm.actionRefreshNotPref();			
		};				
		
	}
	
	loadUser(user) {		
		var userForm = this;
		
		userForm.formPanel.load(user, {
			refreshComponents: true
		});
		
		if (user.userMessagePreference && user.userMessagePreference.lastSendDts) {
			ElementUtil.query(userForm.formPanel, 'lastSent').innerHTML = 'Last Sent: ' + TimeUtil.formatDateStandard(user.userMessagePreference.lastSendDts);
		} else {
			ElementUtil.query(userForm.formPanel, 'lastSent').innerHTML = 'Last Sent: N/A';
		}
	
		if (user.userMessagePreference && user.userMessagePreference.urgencyDelay) {			
			for (var key in user.userMessagePreference.urgencyDelay) {
				userForm.notificationPerference.push({
					urgencyLevel: key,
					delayMinutes: user.userMessagePreference.urgencyDelay[key]
				});
			}
			userForm.actionRefreshNotPref();
		}
		
		userForm.user = user;
	}	
	
};
customElements.define('dl-user-profile-form', UserProfileForm);

